import * as React from 'react';
import CategoryListItem from './CategoryListItem';
import Section from './Section';
import { Category } from '../product';

const mapToCategoryItem = (category: Category, index: number) => (
  <CategoryListItem category={category} key={index} />
);

type Props = {
  categories: Category[];
};

export default function CategoryList(props: Props) {
  return (
    <React.Fragment>
      <Section title="Active">
        {props.categories.map(mapToCategoryItem)}
      </Section>
    </React.Fragment>
  );
}
